type SelfFundingKey = keyof SelfFundingSource;

/**
 * Required keys vary by asset type and whether the client has already started
 * long-term care:
 *   - "Other" + LTC started → only `existingAssetsValue` is required.
 *   - "Other" + pre-LTC → assets, growth, tax.
 *   - Income stream → assets (annual income), tax.
 *   - Specific (non-income-stream) → assets, growth, tax.
 */
export function deriveRequiredKeys({
  isOther,
  isIncomeStream,
  clientHasStartedLtc,
}: {
  isOther: boolean;
  isIncomeStream: boolean;
  clientHasStartedLtc: boolean;
}): SelfFundingKey[] {
  if (isOther) {
    return clientHasStartedLtc
      ? ['existingAssetsValue']
      : ['existingAssetsValue', 'annualRateOfReturn', 'gainsTaxRate'];
  }
  if (isIncomeStream) {
    return ['existingAssetsValue', 'gainsTaxRate'];
  }
  return ['existingAssetsValue', 'annualRateOfReturn', 'gainsTaxRate'];
}
